import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/EventCoordinator.js";
import A11Y from 'HSNDIR/AccessibilityUtility.js';

/**
    * class HSN.AccountMenu
    *
    * Encapsulates the common functionality of the Account Menu 
    **/
HSN.AccountMenu = function () {
    var application;
    var container;
    var events = new HSN.EventCoordinator();
    var customerStateEnum = {
        COLD: 0,
        WARM: 1,
        HOT: 2
    };
    var noAjax;
    var accountMenuContainer;
    var accountBtn;
    var message;
    var subMessage;
    var subMenu;
    var ownershipArrow;
        
    /**
        * new HSN.AccountMenu.init(config)
        * - config (Object): A configuration object for the [[HSN.AccountMenu]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        noAjax = config.noAjax;
        accountMenuContainer = container.find('#account-menu-container');
        accountBtn = container.find('.account-btn');
        message = container.find('.message');
        subMessage = container.find('.sub-message');
        ownershipArrow = container.find('.account-btn .sub-text .arrow');
        bindEvents();
    }

    function bindEvents() {
        if (noAjax) {
            accountBtn.remove();
            container.find('.community').show();
            return;
        }

        //avoid binding open/close events for community sites
        var domainsToDisableDropDown = ['community.hsn.com', 'communityqa.hsn.com', 'blogs.hsn.com'];

        for (var i = 0; i < domainsToDisableDropDown.length; i++) {
            if (document.location.host === domainsToDisableDropDown[i] ) {
                return;
            }
        }

        // To manage outside click on iPad & desktop when Keyboard nav
        var outsideHandler = function (e) {
            if (!$(e.target).parents('#account-menu-container').length) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
            }
        }

        var openOrClose = function() {
            if (accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
            }
            else {
                events.Trigger(HSN.AccountMenu.EVENT.BEFORE_OPEN, false);
                events.Trigger(HSN.AccountMenu.EVENT.OPEN, accountBtn);
            }
        };

        if (!Modernizr.touchevents) {
            accountMenuContainer.on('mouseleave', function() {
                if (accountBtn.hasClass('open')) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            });
            accountMenuContainer.on('mouseenter', function(event) {
                openOrClose();
            });
        }
        else {
            accountBtn.on('touchstart', function (e) {
                e.preventDefault();
                e.stopPropagation();
                openOrClose();
            });
        }

        // For keyboard or misc pointer devices
        accountBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openOrClose();
        }).on('focusout', function (e) {
            setTimeout(function () {
                if (accountBtn.hasClass('open') && !container.find('.sub-menu ul').find(':focus').length) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            }, 100);
        }).on('keydown', function (e) {
            var keys = A11Y.GetKeys();
            var key = e.keyCode || e.which;
            if (key === keys.esc && accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                container.find('#account-menu-container .account-btn').focus();
            } else if (key === keys.spacebar) {
                e.preventDefault();
                e.stopPropagation();
                openOrClose();
            }
        });

        //listen for events within component
        //menu open
        events.On(HSN.AccountMenu.EVENT.OPEN, function (element) {
            ownershipArrow.addClass('active');
            var customerState = application.AccountNavigation.GetCustomerState();
            if (customerState === customerStateEnum.HOT || customerState === customerStateEnum.WARM) {
                subMenu = container.find('.hot-state');
                subMenu.show();
            }
            else {
                subMenu = container.find('.cold-state');
                subMenu.show();
            }

            element.addClass('open');
            element.attr('aria-expanded', true);
            if (Modernizr.touchevents)
                $(document).on('touchstart.accountMenuRollovers', outsideHandler);
            else
                $(document).on('click.accountMenuRollovers', outsideHandler);
        }, this);

        //menu close
        events.On(HSN.AccountMenu.EVENT.CLOSE, function (element) {
                element.removeClass('open');
                element.attr('aria-expanded', false);
                ownershipArrow.removeClass('active');
                if (subMenu) {
                    subMenu.hide();
                }
                $(document).off('.accountMenuRollovers');
            }, this
        );

        //on account status
        HSN.OnAccountStatusLoad(function (data) {
            setCustomerName(data.name);
            container.addClass('show');
        });

        HSN.OnAccountStatusDetailLoad(function (data) {
            setTotalAlerts(data.NumberOfAlerts);
            setMainAlerts(data);
        });

        // close subMenu when it lost focus
        container.find('.sub-menu ul').on('focusout', function (event) {
            setTimeout(function () {
                if (!container.find(':focus').length ) {
                    events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                }
            }, 100);

        });

        // close subMenu when Escape keyboard navigation
        container.find('.sub-menu ul a').on('keydown', function (event) {
            var keys = A11Y.GetKeys();
            var key = event.keyCode || event.which;
            if (key === keys.esc && accountBtn.hasClass('open')) {
                events.Trigger(HSN.AccountMenu.EVENT.CLOSE, accountBtn);
                container.find('#account-menu-container .account-btn').focus();
            }
        });

        
    }

    function setCustomerName(name) {
        if (name) {
            message.text('Hi, ' + name);
            subMessage.text('My Account');
            message.parent().attr('aria-label', 'Hi ' + name + '. My Account Menu');
        }
        else {
            message.text('Hello, Guest');
            subMessage.text('Sign In');
            message.parent().attr('aria-label', 'Hello Guest. Sign In Menu');
            
        }
    }

    function setTotalAlerts(total) {
        if(total > 0) {
            container.find('.alerts .alerts-indicator').show();
            container.find('.alerts .alert-count').text(clampAlertCount(total));
        }
    }

    function setMainAlerts(data) {
        var el = container.find('.main-alerts');
        var total = data.NumberOfAlerts;
        if (total < 1) {
            return;
        }
        if (data.IsKashCouponMenuTestActive) {
            el.addClass('has-count')
              .html(`<div class='alert-count'>${clampAlertCount(total)}</div>`);
        }
        el.show();
    }

    function clampAlertCount(amount) {
        return amount > 9 ? '9+' : amount
    }

    function destroy() {
        application = container = null;
    }

    return {
        init: init,
        destroy: destroy
    }
};

HSN.AccountMenu.EVENT = {
    OPEN: 'HSN.AccountMenu:OPEN',
    CLOSE: 'HSN.AccountMenu:CLOSE',
    BEFORE_OPEN: 'HSN.AccountMenu:BEFORE_OPEN'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/AccountNavigation/AccountMenu.js